<template lang="pug">
div
    app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso="idProcesso",
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
    )
    el-card.card-container(shadow="hover")
        filtro(
            @pesquisar="pesquisar",
            @limpar="clear",
            :showOs="true",
            :showMunicipios="true",
            :configuracaoFiltro="configuracaoFiltro",
            :filtroRapido="filtroRapido"
            :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
        )
    app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
    )
    app-modal-cancelar-retificacao(
    v-if="cancelarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor='setorSelecionado'
    @closeModal="cancelarRetificacao = false"
    @refresh="refresh"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalCancelarRetificacao
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_SOBRESTADO'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      totalElements: 0,
      setorSelecionado: null,
      cancelarRetificacao: false,
      numeroProcesso: '',
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_SOBRESTADO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Município', propriedade: 'municipio', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        {
              id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Fechar Pendência', icone: 'fa-check', codigo: 'FECHAR_PENDENCIA', ordem: 2, show: this.showFecharPendencia },
            { id: 3, nome: 'Fechar Retificação', icone: 'fa-check', codigo: 'FECHAR_RETIFICACAO', ordem: 3, show: this.showEncerrarRetificao }

          ]
        }
      ],
      showFiltroTipoMultiplo,
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.init()
    const user = await this.getUsuario()
    this.idUsuario = user.id
    this.setorSelecionado = user.perfilSelecionado.setor.codigo
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      fecharPendencia: 'conversa/fecharPendencia'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    FECHAR_PENDENCIA (_this, { item }) {
      this.confirmBox(this.$messages.RETORNA_ANALISE, this.$messages.TITULO_WARNING,
        () => {
          this.fecharPendencia(item.id)
            .then(() => {
              _this.refresh()
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.RETIRA_PENDENCIA)
            }).catch(({message}) => {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                message)
            })
        },
        () => {})
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    FECHAR_RETIFICACAO (_this, { item }) {
      this.cancelarRetificacao = true
      this.numeroProcesso = item.numeroProcesso
    }
  }
}
</script>
<style lang="scss" scoped>
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaSobrestado.vue